import { render } from "./inviteMember.vue?vue&type=template&id=30b6b6da&scoped=true"
import script from "./inviteMember.vue?vue&type=script&lang=js"
export * from "./inviteMember.vue?vue&type=script&lang=js"

import "./inviteMember.vue?vue&type=style&index=0&id=30b6b6da&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b6b6da"]])

export default __exports__